export default "__VITE_ASSET__CytbuIP3__"